import ClaimLookup from './ClaimLookup';

export default ClaimLookup;
